import { Inject, Injectable, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthService } from '../../auth/auth/auth.service';
import { AppConfigService } from '../../shared/appconfig/appconfig.service'

import { Help } from '../../shared/models/core.model';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    @Inject('BASE_URL') baseUrl: string) {
  }

  get(category, item): Promise<Help> {
    if (!this.authService.isLoggedIn()) {
      return Promise.reject('User not authenticated');
    }
    return this.http.get<Help>(AppConfigService.settings.get('chatstyleapiServer') + 'help/' + category + '/' + item).toPromise();
  }



}


